module.exports = __webpack_public_path__ + "img/pop_nomoney.92188e3b.png";